var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_54)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_162_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0017 1.64282H15.4236V3.23751H17.2043V6.79898C17.2043 9.48098 15.0222 11.6628 12.3405 11.6628H11.9684C9.28643 11.6628 7.10464 9.4807 7.10464 6.79898V3.23751H8.88537V1.64282H6.30729C5.8669 1.64282 5.50995 1.99978 5.50995 2.44017V6.79898C5.50995 10.3602 8.40725 13.2575 11.9684 13.2575H12.3405C15.9017 13.2575 18.799 10.3602 18.799 6.79898V2.44017C18.799 1.99978 18.4421 1.64282 18.0017 1.64282Z",
    fill: "#48CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3439 0.5C14.9035 0.5 14.5465 0.856953 14.5465 1.29734V3.52991C14.5465 3.9703 14.9035 4.32725 15.3439 4.32725C15.7842 4.32725 16.1412 3.9703 16.1412 3.52991V1.29734C16.1412 0.856953 15.7842 0.5 15.3439 0.5Z",
    fill: "#48CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04484 0.5C8.60445 0.5 8.2475 0.856953 8.2475 1.29734V3.52991C8.2475 3.9703 8.60445 4.32725 9.04484 4.32725C9.48523 4.32725 9.84218 3.9703 9.84218 3.52991V1.29734C9.84218 0.856953 9.48523 0.5 9.04484 0.5Z",
    fill: "#48CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.005 16.9522V12.434H11.4103V16.9522H8.8322C6.75114 16.9522 5.05811 18.6453 5.05811 20.7261C5.05811 22.8071 6.76309 24.5001 8.85878 24.5001H9.23087C11.3119 24.5001 13.005 22.8071 13.005 20.7261V18.5469H15.7159V16.9522H13.005ZM11.4103 20.7258C11.4103 21.9274 10.4325 22.9052 9.23087 22.9052H8.85878C7.62184 22.9052 6.65279 21.9481 6.65279 20.7258C6.65279 19.5242 7.63061 18.5466 8.8322 18.5466H11.4103V20.7258Z",
    fill: "#48CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4436 15.2511C16.0663 15.2511 14.9455 16.3716 14.9455 17.7494C14.9455 19.1267 16.066 20.2475 17.4436 20.2475C18.8211 20.2475 19.9419 19.1267 19.9419 17.7494C19.9419 16.3719 18.8214 15.2511 17.4436 15.2511ZM17.4436 18.6526C16.9455 18.6526 16.5402 18.2473 16.5402 17.7492C16.5402 17.2509 16.9455 16.8456 17.4436 16.8456C17.9419 16.8456 18.3472 17.2509 18.3472 17.7492C18.3472 18.2473 17.9419 18.6526 17.4436 18.6526Z",
    fill: "#48CAE4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_162_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasient);
export default __webpack_public_path__ + "static/media/pasient.24cbb3999190e65aa1048766d577c4c6.svg";
export { ForwardRef as ReactComponent };